import React from "react";
import Header from "./Header";
import LoadingScreen from "./LoadingScreen";

function ContainerDefault({ loading, online, ...props }) {

  return <>
    <LoadingScreen opacity={0.8} loading={loading} />
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header online={online} />
      <div style={{ flex: 1 }}>
        {props.children}
      </div>
    </div>
  </>;
}

export default ContainerDefault;
